// parse metric from the order and return metric without prefixes `metric_` and `_plan`/`_planned`
function getPlanMetric (metricId) {

  // in orders get metrics only with prefix `metric_`
  const isOrderMetric = metricId.indexOf('metric_') === 0;
  if (isOrderMetric) {
    const orderMetric = metricId.split('metric_')[1];
    if (orderMetric.indexOf('_planned') > 0) {
      return orderMetric.split('_planned')[0];
    } else if (orderMetric.indexOf('_plan') > 0) {
      return orderMetric.split('_plan')[0];
    }
    return false;
  }
  return false;
}

export {getPlanMetric};
